import * as yup from 'yup';

import { createHighestRateValidation, createLowestRateValidation } from 'src/utils/validations';

import { TWO_TOGGLE_PRICING_TYPES } from '../components/TwoToggleRates';
import { ADDITIONAL_TARIFFS_PERSONAL_CARDS } from '../sections/AdditionalTariffs';

const getValidationShape = () => {
    const perItemValidation = yup
        .number()
        .when('type', (type: string, schema: yup.NumberSchema) => {
            return type === 'PER_ITEM' ? schema.required() : schema.notRequired();
        });

    const fixedRateValidation = yup
        .number()
        .when('type', (type: string, schema: yup.NumberSchema) => {
            return type === 'FIXED' ? schema.required() : schema.notRequired();
        });

    const typeOptions = TWO_TOGGLE_PRICING_TYPES.map((item) => {
        return item.value;
    });

    const cardSchema = yup.object().shape({
        type: yup.string().oneOf(typeOptions),
        baseRate: perItemValidation,
        lowestRate: perItemValidation.test(
            'lowest-rate-validation',
            'Lowest rate cannot exceed highest rate',
            createLowestRateValidation('lowestRate', 'highestRate')
        ),
        highestRate: perItemValidation.test(
            'highest-rate-validation',
            'Highest rate cannot be less than lowest rate',
            createHighestRateValidation('lowestRate', 'highestRate')
        ),
        fixedRate: fixedRateValidation,
    });

    return ADDITIONAL_TARIFFS_PERSONAL_CARDS.reduce(
        (acc, { name }) => {
            return {
                ...acc,
                [name]: cardSchema,
            };
        },
        {} as Record<string, yup.ObjectSchema<any>>
    );
};

export const ADDITIONAL_TARIFFS_VALIDATION_SCHEMA = yup.object({
    personalCards: yup.object().shape(getValidationShape()).required('Required'),
});
